var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.21,
    height: 10.17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.34 10l6.23-3.74a1.33 1.33 0 000-2.27L10.31.19a1.33 1.33 0 00-2 1.14V3h-7A1.32 1.32 0 000 4.27v1.62a1.33 1.33 0 001.32 1.33h7v1.63A1.32 1.32 0 0010.34 10z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTcuMjEiIGhlaWdodD0iMTAuMTciIHZpZXdCb3g9IjAgMCAxNy4yMSAxMC4xNyI+CiAgPHBhdGggZD0iTTEwLjM0LDEwbDYuMjMtMy43NGExLjMzLDEuMzMsMCwwLDAsMC0yLjI3TDEwLjMxLjE5YTEuMzMsMS4zMywwLDAsMC0yLDEuMTRWM2gtN0ExLjMyLDEuMzIsMCwwLDAsMCw0LjI3VjUuODlBMS4zMywxLjMzLDAsMCwwLDEuMzIsNy4yMmg3VjguODVBMS4zMiwxLjMyLDAsMCwwLDEwLjM0LDEwWiIvPgo8L3N2Zz4K";
export { SvgArrowRight as ReactComponent };